import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../app/store";
import { useNavigate } from "react-router-dom";
import { GetTodayStat, GetTotalStat } from "api/services/stat";
import { setTodayStat, setTotalStat } from "reducers/statReducer";
import { GetTodayStatProps, GetTotalStatProps } from "declarations/statServices";
import { setProgressBarActive } from "reducers/pageReducer";
import { useAsyncOperation } from "./useAsyncOperation";

export default function useStat() {
  const { execute } = useAsyncOperation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { todayStat, totalStat } = useSelector((state: RootState) => state.stat);

  const getTotalStat = async ({
    limit,
    offset,
    setLoading,
  }: GetTotalStatProps) => {
    try {
      
      const response = await execute(
        () => GetTotalStat({ setLoading, offset, limit }),
        { errorMessage: "Fetching Total Statistics Failed" }
      );
      
      const { stat, message, status } = response;
      
      if (status !== 200) throw new Error(message);
      
      dispatch(setTotalStat(stat));
    } catch (error) {}
  };

  const getTodayStat = async ({
    limit,
    offset,
    setLoading,
  }: GetTodayStatProps) => {
    try {
      
      const response = await execute(
        () => GetTodayStat({ setLoading, offset, limit }),
        { errorMessage: "Fetching Today Statistics Failed" }
      );
      
      const { stat, message, status } = response;
      
      if (status !== 200) throw new Error(message);
      
      dispatch(setTodayStat(stat));
    } catch (error) {}
  };

  return {
    getTotalStat,
    getTodayStat,
  };
}
